import { r as o } from "./chunk-PVWAREVJ-BO6B-RAk.js";
const a = (r) => ({
  getRoutes: () => r.redirects.map(({ from: e, to: t }) => ({
    path: e,
    loader: () => o(t, 301)
  }))
});
export {
  a as redirectPlugin
};
//# sourceMappingURL=zudoku.plugin-redirect.js.map
